import React from 'react';
import "./button.scss";
import { Link } from 'gatsby';
import ExternalLink from '../external-link/externalLink';

const Button = ({ to, external, className, onClick, buttonType, children }) => {
  if (external) {
    return (
      <ExternalLink href={to} className={`btn ${className}`}>
        {children}
      </ExternalLink>
    );
  }

  if (buttonType === 'submit' || !to) {
    return (
      <button type={`${buttonType === 'submit' ? 'submit' : ''}`}
        className={`btn ${className}`}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  return <Link
    to={to}
    className={`btn ${className}`}
    onClick={onClick}
  >
    {children}
  </Link>;
};

export default Button;
